import { FIELD_TYPES } from "/constants/template-field-type";
export default {
    variant: {
        type: FIELD_TYPES.COMBO,
        label: "Color",
        options: [
            {
                value: "Base",
                text: "Base"
            },
            {
                value: "PurpleCTA",
                text: "Purple"
            }
        ]
    }
};
